import { render, staticRenderFns } from "./YearCalendarHolderTest.vue?vue&type=template&id=c0d9d76e&scoped=true&"
import script from "./YearCalendarHolderTest.vue?vue&type=script&lang=js&"
export * from "./YearCalendarHolderTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d9d76e",
  null
  
)

export default component.exports